import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import "react";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ErrorNotFoundImage_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else ErrorNotFoundImage_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
const ErrorNotFoundImage = (t0)=>{
    const $ = c(29);
    let props;
    if ($[0] !== t0) {
        props = _extends({}, t0);
        $[0] = t0;
        $[1] = props;
    } else props = $[1];
    let t1;
    let t10;
    let t11;
    let t12;
    let t13;
    let t14;
    let t15;
    let t16;
    let t17;
    let t18;
    let t19;
    let t2;
    let t20;
    let t21;
    let t22;
    let t23;
    let t24;
    let t25;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    let t8;
    let t9;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ jsx("path", {
            d: "M66.6514 118.825C62.8034 86.4946 85.8932 57.166 118.224 53.3181L205.674 42.9099C238.005 39.062 267.334 62.1518 271.182 94.4824C275.029 126.813 251.94 156.142 219.609 159.99L132.159 170.398C99.8279 174.246 70.4993 151.156 66.6514 118.825Z",
            fill: "#99BCFF"
        });
        t2 = /*#__PURE__*/ jsx("path", {
            d: "M220.011 103.21C220.447 102.195 221.624 101.727 222.639 102.163C223.654 102.6 224.122 103.775 223.686 104.79L214.981 125.035L231.077 125.746L235.114 114.276C235.48 113.234 236.623 112.687 237.665 113.054C238.706 113.42 239.254 114.563 238.887 115.604L228.66 144.664C228.293 145.706 227.151 146.253 226.109 145.887C225.067 145.52 224.52 144.378 224.886 143.336L229.689 129.688L211.913 128.904C211.256 128.875 210.655 128.525 210.306 127.969C209.957 127.412 209.904 126.72 210.164 126.116L220.011 103.21Z",
            fill: "#226DFE"
        });
        t3 = /*#__PURE__*/ jsx("path", {
            d: "M219.011 102.21C219.447 101.195 220.624 100.727 221.639 101.163C222.654 101.6 223.122 102.775 222.686 103.79L213.981 124.035L230.077 124.746L234.114 113.276C234.48 112.234 235.623 111.687 236.665 112.054C237.706 112.42 238.254 113.563 237.887 114.604L227.66 143.664C227.293 144.706 226.151 145.253 225.109 144.887C224.067 144.52 223.52 143.378 223.886 142.336L228.689 128.688L210.913 127.904C210.256 127.875 209.655 127.525 209.306 126.969C208.957 126.412 208.904 125.72 209.164 125.116L219.011 102.21Z",
            fill: "#EDF3FF"
        });
        t4 = /*#__PURE__*/ jsx("path", {
            d: "M113.011 113.21C113.447 112.195 114.624 111.727 115.639 112.163C116.654 112.6 117.122 113.775 116.686 114.79L107.981 135.035L124.077 135.746L128.114 124.276C128.48 123.234 129.623 122.687 130.665 123.054C131.706 123.42 132.254 124.563 131.887 125.604L121.66 154.664C121.293 155.706 120.151 156.253 119.109 155.887C118.067 155.52 117.52 154.378 117.886 153.336L122.689 139.688L104.913 138.904C104.256 138.875 103.655 138.525 103.306 137.969C102.957 137.412 102.904 136.72 103.164 136.116L113.011 113.21Z",
            fill: "#226DFE"
        });
        t5 = /*#__PURE__*/ jsx("path", {
            d: "M112.011 112.21C112.447 111.195 113.624 110.727 114.639 111.163C115.654 111.6 116.122 112.775 115.686 113.79L106.981 134.035L123.077 134.746L127.114 123.276C127.48 122.234 128.623 121.687 129.665 122.054C130.706 122.42 131.254 123.563 130.887 124.604L120.66 153.664C120.293 154.706 119.151 155.253 118.109 154.887C117.067 154.52 116.52 153.378 116.886 152.336L121.689 138.688L103.913 137.904C103.256 137.875 102.655 137.525 102.306 136.969C101.957 136.412 101.904 135.72 102.164 135.116L112.011 112.21Z",
            fill: "#EDF3FF"
        });
        t6 = /*#__PURE__*/ jsx("path", {
            d: "M135.582 55.8774C131.404 71.3522 150.479 75.9323 169.248 75.9686C188.018 76.0049 207.164 70.4595 203.56 56.008C199.765 40.896 188.394 28.0124 169.624 27.9689C150.854 27.9253 139.639 40.7872 135.582 55.8774Z",
            fill: "#EDF3FF"
        });
        t7 = /*#__PURE__*/ jsx("path", {
            d: "M170.499 27.9805C188.747 28.4157 199.824 41.1322 203.56 56.008C207.164 70.4595 188.018 76.0049 169.248 75.9686L169.25 74.9688C178.568 74.9867 187.875 73.6143 194.364 70.5186C197.602 68.9736 200.062 67.0353 201.508 64.7021C202.936 62.3992 203.431 59.6236 202.589 56.25C198.874 41.4613 187.818 29.011 169.622 28.9688C151.433 28.9267 140.524 41.3471 136.547 56.1367C135.56 59.7933 135.967 62.7029 137.308 65.043C138.665 67.4095 141.048 69.3168 144.233 70.8066C150.624 73.7963 159.908 74.9507 169.25 74.9688L169.248 75.9686L167.489 75.9521C149.309 75.6359 131.534 70.8687 135.582 55.8774C139.639 40.7872 150.854 27.9253 169.624 27.9689L170.499 27.9805Z",
            fill: "#226DFE"
        });
        t8 = /*#__PURE__*/ jsx("path", {
            d: "M154.134 34.1517C157.564 32.0888 161.554 35.1239 158.608 38.2377C157.106 39.8291 150.657 42.1846 149.885 40.0625C149.114 37.9405 151.794 35.5008 154.134 34.1517Z",
            fill: "white"
        });
        t9 = /*#__PURE__*/ jsx("path", {
            d: "M235 77.9015C235 90.0475 204.479 92.9688 170.533 92.9688C136.587 92.9688 106 90.3594 106 78.2135C106 66.0676 129.238 48.4691 170.533 48.9796C210.13 49.4689 235 65.7272 235 77.9015Z",
            fill: "#EDF3FF"
        });
        t10 = /*#__PURE__*/ jsx("path", {
            d: "M234 77.9014C234 75.1984 232.613 72.1293 229.756 68.9883C226.909 65.8579 222.671 62.7362 217.165 59.9513C206.155 54.3835 190.192 50.2227 170.52 49.9796C150.011 49.7261 134.049 53.9709 123.251 59.7325C117.851 62.6143 113.765 65.8634 111.041 69.0948C108.309 72.3359 107 75.4925 107 78.2139C107.001 80.7429 108.565 82.9126 111.808 84.7764C115.058 86.6442 119.81 88.0839 125.716 89.1621C137.511 91.3153 153.567 91.9688 170.533 91.9688L170.533 92.9688C136.852 92.9688 106.478 90.4 106.006 78.4961L106 78.2135C106 66.0676 129.238 48.4691 170.533 48.9796C210.13 49.4689 235 65.7272 235 77.9015C235 90.0475 204.479 92.9688 170.533 92.9688L170.533 91.9688C187.495 91.9688 203.533 91.238 215.31 89.0078C221.207 87.8911 225.952 86.4128 229.197 84.5166C232.436 82.624 234 80.4343 234 77.9014Z",
            fill: "#226DFE"
        });
        t11 = /*#__PURE__*/ jsx("path", {
            d: "M170.5 104.969C206.123 104.969 235 94.4474 235 81.4688C235 68.4901 206.123 57.9688 170.5 57.9688C134.878 57.9688 106 68.4901 106 81.4688C106 94.4474 134.878 104.969 170.5 104.969Z",
            fill: "#D8E5FF"
        });
        t12 = /*#__PURE__*/ jsx("path", {
            d: "M234 81.4688C234 78.6244 232.421 75.7859 229.279 73.0791C226.14 70.375 221.538 67.8941 215.766 65.791C204.23 61.5879 188.226 58.9688 170.5 58.9688C152.775 58.9688 136.771 61.5879 125.235 65.791C119.463 67.8941 114.861 70.375 111.722 73.0791C108.58 75.7859 107 78.6244 107 81.4688C107 84.3131 108.58 87.1516 111.722 89.8584C114.861 92.5625 119.463 95.0434 125.235 97.1465C136.771 101.35 152.775 103.969 170.5 103.969L170.5 104.969L168.835 104.961C133.983 104.639 106 94.2446 106 81.4688C106 68.4901 134.878 57.9688 170.5 57.9688L172.165 57.9766C207.018 58.2983 235 68.6929 235 81.4688C235 94.4474 206.123 104.969 170.5 104.969L170.5 103.969C188.226 103.969 204.23 101.35 215.766 97.1465C221.538 95.0434 226.14 92.5625 229.279 89.8584C232.421 87.1516 234 84.3131 234 81.4688Z",
            fill: "#226DFE"
        });
        t13 = /*#__PURE__*/ jsx("path", {
            d: "M170.5 105.969C191.763 105.969 209 98.8053 209 89.9688C209 81.1322 191.763 73.9688 170.5 73.9688C149.237 73.9688 132 81.1322 132 89.9688C132 98.8053 149.237 105.969 170.5 105.969Z",
            fill: "white"
        });
        t14 = /*#__PURE__*/ jsx("path", {
            d: "M208 89.9688C208 88.1089 207.098 86.2459 205.274 84.4541C203.447 82.6589 200.752 80.9958 197.34 79.5781C190.522 76.7445 181.033 74.9688 170.5 74.9688C159.968 74.9688 150.479 76.7446 143.661 79.5781C140.249 80.9958 137.554 82.6589 135.727 84.4541C133.903 86.2459 133 88.1089 133 89.9688C133 91.8286 133.903 93.6916 135.727 95.4834C137.554 97.2786 140.249 98.9417 143.661 100.359C150.479 103.193 159.968 104.969 170.5 104.969V105.969L169.506 105.964C148.703 105.745 132 98.6672 132 89.9688C132 81.1322 149.237 73.9688 170.5 73.9688L171.495 73.9736C192.298 74.1928 209 81.2703 209 89.9688C209 98.8053 191.763 105.969 170.5 105.969V104.969C181.033 104.969 190.522 103.193 197.34 100.359C200.752 98.9417 203.447 97.2786 205.274 95.4834C207.098 93.6916 208 91.8286 208 89.9688Z",
            fill: "#226DFE"
        });
        t15 = /*#__PURE__*/ jsx("path", {
            d: "M204.501 97.5C206.837 95.8311 208.8 92.6656 209.001 90.5C212.371 93.4766 215.436 93.9437 223.159 93.9088C208.656 101.115 195.649 102.093 195.649 102.093C199.599 100.288 201.001 100 204.501 97.5Z",
            fill: "#B8CEFA"
        });
        t16 = /*#__PURE__*/ jsx("path", {
            d: "M116.991 93.4613C116.991 93.4613 121.772 95.4931 124.802 94.8052C128.228 94.0272 132.065 88.9929 132.065 88.9929C131.884 95.6046 136.671 97.8661 145.408 102.114C128.587 99.2297 123.704 96.7618 116.991 93.4613Z",
            fill: "#B8CEFA"
        });
        t17 = /*#__PURE__*/ jsx("path", {
            d: "M131 155C161.816 160.91 180.047 161.016 212.5 155C195.5 103.5 195.035 86.4019 169.312 85.9732C143.589 85.5445 144.776 116.25 131 155Z",
            fill: "#EDF3FF"
        });
        t18 = /*#__PURE__*/ jsx("path", {
            d: "M191.115 122.29C191.115 123.547 190.9 124.486 189.95 125.28C188.154 126.78 181.277 120.282 181.206 118.102C181.115 115.301 188.141 117.198 189.95 119.299C190.761 120.241 191.115 121.032 191.115 122.29Z",
            fill: "white"
        });
        t19 = /*#__PURE__*/ jsx("path", {
            d: "M190.616 122.289C190.616 121.71 190.535 121.264 190.373 120.863C190.211 120.458 189.955 120.071 189.571 119.624C189.185 119.177 188.481 118.701 187.595 118.284C186.72 117.871 185.714 117.538 184.77 117.353C183.813 117.165 182.975 117.141 182.411 117.294C182.134 117.37 181.959 117.478 181.857 117.594C181.764 117.7 181.699 117.848 181.706 118.086C181.712 118.248 181.787 118.509 181.973 118.869C182.154 119.218 182.417 119.62 182.747 120.051C183.407 120.913 184.305 121.859 185.26 122.695C186.219 123.534 187.211 124.243 188.053 124.648C188.475 124.851 188.834 124.965 189.115 124.995C189.393 125.024 189.544 124.968 189.629 124.897C190.038 124.555 190.276 124.196 190.417 123.793C190.563 123.38 190.616 122.895 190.616 122.289ZM191.616 122.289C191.616 122.942 191.56 123.556 191.361 124.124C191.157 124.704 190.812 125.212 190.27 125.664C189.906 125.968 189.449 126.036 189.008 125.989C188.569 125.942 188.095 125.777 187.619 125.548C186.665 125.089 185.596 124.318 184.602 123.448C183.605 122.575 182.658 121.581 181.952 120.659C181.6 120.198 181.3 119.745 181.084 119.328C180.874 118.921 180.719 118.502 180.706 118.119C180.691 117.656 180.826 117.251 181.107 116.933C181.379 116.625 181.752 116.437 182.149 116.33C182.932 116.116 183.948 116.173 184.962 116.372C185.989 116.573 187.073 116.933 188.021 117.379C188.958 117.821 189.809 118.369 190.328 118.972C190.755 119.468 191.084 119.949 191.301 120.49C191.52 121.033 191.616 121.611 191.616 122.289Z",
            fill: "#226DFE"
        });
        t20 = /*#__PURE__*/ jsx("path", {
            d: "M167.259 96.9048C167.194 97.6222 167.272 98.1625 167.443 98.5747C167.612 98.9824 167.879 99.2866 168.233 99.522C168.962 100.007 170.043 100.198 171.331 100.328C172.586 100.454 174.024 100.522 175.326 100.81C176.638 101.1 177.882 101.625 178.746 102.712C179.798 104.036 179.438 105.852 178.733 107.622C178.373 108.524 177.907 109.457 177.436 110.368C176.962 111.284 176.485 112.175 176.092 113.015C175.698 113.857 175.402 114.622 175.279 115.279C175.156 115.937 175.217 116.432 175.466 116.79C175.715 117.147 176.209 117.449 177.137 117.59C178.064 117.731 179.374 117.704 181.176 117.449L181.274 118.141C179.443 118.4 178.056 118.439 177.032 118.283C176.008 118.127 175.295 117.769 174.892 117.19C174.489 116.612 174.452 115.895 174.591 115.15C174.731 114.404 175.058 113.575 175.458 112.719C175.859 111.862 176.346 110.95 176.814 110.046C177.284 109.137 177.737 108.231 178.082 107.363C178.788 105.591 178.983 104.135 178.199 103.147C177.477 102.239 176.414 101.766 175.175 101.493C173.926 101.217 172.569 101.156 171.261 101.024C169.987 100.896 168.737 100.699 167.845 100.105C167.388 99.8005 167.022 99.391 166.795 98.8423C166.57 98.2981 166.49 97.6383 166.562 96.8423L167.259 96.9048Z",
            fill: "#226DFE"
        });
        t21 = /*#__PURE__*/ jsx("path", {
            d: "M152.665 114.57C152.827 113.937 153.543 113.628 154.115 113.943L171.85 123.697C172.243 123.914 172.444 124.366 172.341 124.804L166.854 148.004L147.577 137.4C147.177 137.18 146.976 136.717 147.09 136.275L152.665 114.57Z",
            fill: "#D8E5FF"
        });
        t22 = /*#__PURE__*/ jsx("path", {
            d: "M171.85 123.697C172.243 123.914 172.444 124.366 172.341 124.804L166.854 148.004L147.577 137.4L148.058 136.524L166.183 146.493L171.367 124.573L153.632 114.818L148.058 136.524L147.577 137.4L147.435 137.306C147.175 137.099 147.034 136.774 147.062 136.442L147.09 136.275L152.665 114.57C152.827 113.937 153.543 113.628 154.115 113.943L171.85 123.697Z",
            fill: "#226DFE"
        });
        t23 = /*#__PURE__*/ jsx("path", {
            d: "M168.203 144.431L180.08 151.325L178.709 154.647L167.295 148.183L168.203 144.431Z",
            fill: "#D8E5FF"
        });
        t24 = /*#__PURE__*/ jsx("path", {
            d: "M180.08 151.325L178.709 154.647L167.295 148.183L168.203 144.431L180.08 151.325ZM168.445 147.684L178.218 153.218L178.822 151.752L168.859 145.968L168.445 147.684Z",
            fill: "#226DFE"
        });
        t25 = /*#__PURE__*/ jsx("path", {
            d: "M170.615 85.5C177.477 85.5 182.614 87.0785 186.695 90.1855C190.765 93.2846 193.731 97.8656 196.332 103.771C198.931 109.673 201.186 116.952 203.801 125.479C206.419 134.015 209.404 143.824 213.469 154.827L212.532 155.173C208.456 144.139 205.462 134.305 202.845 125.771C200.225 117.229 197.987 110.012 195.416 104.174C192.847 98.3383 189.966 93.9332 186.089 90.9814C182.223 88.0377 177.315 86.5 170.615 86.5C163.919 86.5 159.074 88.1179 155.325 91.1582C151.563 94.2085 148.851 98.7334 146.51 104.652C144.168 110.573 142.218 117.831 139.945 126.312C137.674 134.784 135.086 144.455 131.474 155.16L130.527 154.84C134.128 144.169 136.708 134.527 138.979 126.054C141.247 117.59 143.213 110.27 145.581 104.284C147.949 98.2974 150.74 93.5881 154.695 90.3809C158.662 87.1636 163.747 85.5 170.615 85.5Z",
            fill: "#226DFE"
        });
        $[2] = t1;
        $[3] = t10;
        $[4] = t11;
        $[5] = t12;
        $[6] = t13;
        $[7] = t14;
        $[8] = t15;
        $[9] = t16;
        $[10] = t17;
        $[11] = t18;
        $[12] = t19;
        $[13] = t2;
        $[14] = t20;
        $[15] = t21;
        $[16] = t22;
        $[17] = t23;
        $[18] = t24;
        $[19] = t25;
        $[20] = t3;
        $[21] = t4;
        $[22] = t5;
        $[23] = t6;
        $[24] = t7;
        $[25] = t8;
        $[26] = t9;
    } else {
        t1 = $[2];
        t10 = $[3];
        t11 = $[4];
        t12 = $[5];
        t13 = $[6];
        t14 = $[7];
        t15 = $[8];
        t16 = $[9];
        t17 = $[10];
        t18 = $[11];
        t19 = $[12];
        t2 = $[13];
        t20 = $[14];
        t21 = $[15];
        t22 = $[16];
        t23 = $[17];
        t24 = $[18];
        t25 = $[19];
        t3 = $[20];
        t4 = $[21];
        t5 = $[22];
        t6 = $[23];
        t7 = $[24];
        t8 = $[25];
        t9 = $[26];
    }
    let t26;
    if ($[27] !== props) {
        t26 = /*#__PURE__*/ jsxs("svg", _object_spread_props(_object_spread({
            width: "340",
            height: "200",
            viewBox: "0 0 340 200",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, props), {
            children: [
                t1,
                t2,
                t3,
                t4,
                t5,
                t6,
                t7,
                t8,
                t9,
                t10,
                t11,
                t12,
                t13,
                t14,
                t15,
                t16,
                t17,
                t18,
                t19,
                t20,
                t21,
                t22,
                t23,
                t24,
                t25
            ]
        }));
        $[27] = props;
        $[28] = t26;
    } else t26 = $[28];
    return t26;
};
export { ErrorNotFoundImage };
